import React from 'react';
import { AboutMain } from '../components/styles';

export default function About() {
  return (
    <>
      <AboutMain>
        <p>
          Hi there! I'm Tommy Tran and I'm fullstack developer with a background in Biochemistry and Pre-Dental. I enjoy learning new concepts and technologies to come up with clean and efficient solutions. I got into tech because I value progress, and I realized that the manifestation of progress is through technology. My general life goal is to build the future!
        </p>
      </AboutMain>
    </>
  );
}
